import { createAction, handleActions } from 'redux-actions';

export const types = {
  sidebarMenuCollapsed: 'SIDEBAR_MENU_COLLAPSED',
  sidebarMenuItemSelect: 'SIDEBAR_MENU_ITEM_SELECT',
  sidebarMenuItemSelected: 'SIDEBAR_MENU_ITEM_SELECTED',
  sidebarMenuItemPrint: 'SIDEBAR_MENU_ITEM_PRINT',
  sidebarMenuItemPrinted: 'SIDEBAR_MENU_ITEM_PRINTED',
};

export const sidebarMenuCollapsed = createAction(types.sidebarMenuCollapsed);

export const sidebarMenuItemSelect = createAction(types.sidebarMenuItemSelect);

export const sidebarMenuItemSelected = createAction(types.sidebarMenuItemSelected);

export const sidebarMenuItemPrint = createAction(types.sidebarMenuItemPrint);

export const sidebarMenuItemPrinted = createAction(types.sidebarMenuItemPrinted);

export const INITIAL_STATE = {
  collapsed: true,
  menuItemSelected: '1',
};

export const sideBarReducer = handleActions(
  {
    [types.sidebarMenuCollapsed]: state => ({
      ...state,
      collapsed: !state.collapsed,
    }),
    [types.sidebarMenuItemSelected]: (state, action) => ({
      ...state,
      menuItemSelected:
        ['4', '5'].indexOf(action.payload.menuItemSelected) >= 0
          ? state.menuItemSelected
          : action.payload.menuItemSelected,
    }),
  },
  INITIAL_STATE
);
